import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SharedConstants, User } from '../models';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { EnumRoutesDefault } from '../models/shared/app-enums';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Constants } from 'src/assets/Constats';

@Injectable({
  providedIn: 'root'
})
export class ErrorCustomService {
  private cookieService = inject(CookieService);
  currentUserSubject: BehaviorSubject<User>;
  currentUser: Observable<User>;

  constructor(
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly sharedConstants: SharedConstants
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser') || '{}'));

  }

  onValidateErrorCode(error: Response) {
    console.log(error);
    let _code = error.status;
    if (_code == 0) {
      
      Swal.fire({
        text: "No fue posible procesar su solicitud debido a que ocurrió un error al intentar conectar con el servidor, es posible que no esté disponible. ¿Desea cerrar sesión?.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        denyButtonText: "No",
        cancelButtonText: "Cancelar",
        confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
        cancelButtonColor: Constants.SWEET_ALERT_PROPERTIES.cancelButtonColor,
      }).then((result) => {
        if (result.value) {

          if (result.isConfirmed) {
            this.currentUserSubject.next(null);
            this.cookieService.deleteAll();
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate([EnumRoutesDefault.Login]);
          }
          else if (result.isDenied) {
            Swal.close();
          }
        }
      });

      //this.toastr.warning("No fue posible procesar su solicitud debido a que el servidor no está disponible. Intente más tarde.");
      // setTimeout(() => {
      //   this.currentUserSubject.next(null);
      //   this.cookieService.deleteAll();
      //   localStorage.clear();
      //   sessionStorage.clear();
      //   this.router.navigate([EnumRoutesDefault.Login]);
      // }, 3000); 

    }
    else {
      this.toastr.error(this.sharedConstants.messages.serverError);
    }
  }
}
